{
  "CustomisePopupTitle": "Administratorrolle anpassen",
  "FooterActionsSubmit": "Einreichen",
  "FooterActionsCancel": "Absagen",
  "FooterActionsHelp": "Hilfe?",
  "TableHeadingAdminAccess": "Verwaltungszugriff",
  "HeadingAdministrate": "Administrieren",
  "HeadingView": "Aussicht",
  "HeadingAdd": "Hinzufügen",
  "HeadingModify": "Veränderung",
  "HeadingDelete": "Löschen",
  "EntryCme": "CME-Management",
  "EntryDevices": "Geräte",
  "EntryDevicesSub": "(Nebenstellen \/ Gruppen \/ Andere Geräte)",
  "EntryAgents": "Agenten",
  "EntryDirectory": "Verzeichnisse",
  "EntryApplicationUsers": "Anwendungsbenutzer",
  "EntryCodes": "Codes",
  "EntryTelServers": "Telefonie-Server",
  "EntryPartition": "Partitionen",
  "EntryOmnichannel": "Omnichannel",
  "EntryRecordings": "Aufzeichnung",
  "EntryMessages": "Mitteilungen",
  "EntryDatabase": "Datenbank",
  "TableHeadingStatusTools": "Zugriff auf Status und Tools",
  "HeadingSection": "Abschnitt",
  "EntryLicences": "Lizenzen",
  "EntryLogging": "Protokollierung",
  "EntryLogManagement": "Protokollverwaltung",
  "EntryAuditTrail": "Buchungskontrolle",
  "EntryTelephoneModuleStatus": "Status des Telefonmoduls",
  "EntryOmnichannelStatus": "Omnichannel-Status",
  "EntryCallControl": "Anrufsteuerung",
  "EntryServerStatus": "Server Status",
  "TableHeadingActions": "Aktionen",
  "HeadingAction": "Aktion",
  "HeadingAllowed": "Erlaubt",
  "EntryCopyReportsTo": "Berichte kopieren nach...",
  "EntrySignInAs": "Anmelden als...",
  "EntryBillingFilesDownload": "Rechnungs-CDRs",
  "EntryBillingSummary": "Rechnungsübersicht",
  "EntryChangeLicenceLevel": "Lizenzstufe ändern",
  "SyncPartition": "Partition synchronisieren",
  "ViewChangedWarning": "Ohne die Ansichtsoption kann {} nur {} sein, wenn die API verwendet wird.",
  "Update": "Aktualisiert",
  "Delete": "gelöscht",
  "ViewChangeOr": "oder",
  "CustomiseRole_Add": "hinzugefügt",
  "NAME": "CustomiseRole",
  "EntryUserRole": "Benutzer-Rollen",
  "EntryChangeTelephonyServerBillingStatus": "Abrechnungsstatus des Telefonservers ändern",
  "EptAccess": "Werkzeug zur einfachen Bereitstellung",
  "EntryLogFilesDownload": "Log-Dateien herunterladen",
  "TelSysSyncRestrictions": "Maximale Synchronisierungsparameter ändern",
  "CMEBrandingConfig": "CME-Branding-Konfiguration",
  "EntryCrm": "CRM-Management",
  "EntryClientConfig": "Client-Konfiguration",
  "EditOwningCMEDomainProfile": "CME-Domänenprofil bearbeiten",
  "EditOwningCMEBranding": "CME-Branding bearbeiten",
  "EditOwningCMEProvisioning": "CME-Bereitstellung bearbeiten (Service Pack-Synchronisierung)"
}